import React, { useState } from 'react'
import { Typography, Box } from '@mui/material'

// Local imports
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'

// API services
import { useDeleteCustomHoliday } from 'services/api/modules/leave/holiday'
import AdxButton from 'components/custom/AdxButton'

const DeleteCustomModal = ({ state }) => {
  const [modalState, setModalState] = useState(false)
  const mutation = useDeleteCustomHoliday()

  const handleOpen = () => {
    setModalState(true)
  }

  const handleClose = () => {
    setModalState(false)
  }

  return (
    <>
      <AdxButton variant={'ghost'} size="small" color="error" onClick={handleOpen}>
        Delete
      </AdxButton>
      <AdxInfoModal
        variant={'error'}
        title="Are you sure you want to delete"
        subtitle={state.name}
        open={modalState}
        onClose={handleClose}
        handleClose={handleClose}
        muiIcon="error"
        iconColor="error.main"
        footerButtons
        firstBtnLabel={'Delete'}
        firstBtnHandle={() => {
          mutation.mutate(state.id)
        }}
        secondBtnLabel={'Cancel'}
        secondBtnHandle={handleClose}
      ></AdxInfoModal>
    </>
  )
}

export default DeleteCustomModal
